module.exports = __webpack_public_path__ + "static/media/buyorders.fba9a89c.svg";